export default __webpack_public_path__ + "static/media/login.1e4196ab.jpg";